module.exports = new __parcel__URL__("trust.e6732b19.png").toString();